export default __webpack_public_path__ + "static/media/Insurance-Proposal-Form-November 2024.72f6255b.pdf";